module.exports = __webpack_public_path__ + "img/u2.db89da45.jpg";